var NewAddressForm = (function (_decoration, _FieldView, $el, _prefix) {

    if (_prefix) {
        _prefix = _prefix.replace(/_$/i, '') + '_';
        _decoration.each(function(model) {
            var fieldName = model.get('Name');
            model.set('Name', _prefix + fieldName);
        });
    }

    var _renderField = function ($el, model) {
        var view = new _FieldView({ model: model });
        view.model.off('remove');
        $el.append(view.$el);
    }

    var _renderFields = function() {
        _decoration.each(_.bind(_renderField, this, $el));
    }

    return {
        render: _renderFields,
        getData: function() {
            
        },
        clear: function() {
            
        }
    }

});